<template>
    <Modal>
        <template v-slot:header>
            <h3 style="margin-bottom: 0px">{{ $t('common.reservation.travelDates') }}</h3>
        </template>
        <template v-slot:content>
            <div class="row ">
                <div class="col d-flex justify-content-center">
                    <CoreDatePicker 
                        v-model="proxy" 
                        :bookings="bookings"
                        :columns="$screens({ default: 1, lg: 3 })"
                        :rows="$screens({ default: 1})"   
                    ></CoreDatePicker>
            </div>
            <div class="row">
                <div class="col">
                    <Toggle 
                        :title="$t('common.reservation.specialOffersOnly')" 
                        v-model="specialOffer" 
                        style="margin-top: 12px; margin-bottom: 12px; margin-left: 8px"
                    />
                </div>
            </div>
        </div>
        </template>
        <template v-slot:actions>
            <button class="btn btn-outline-primary" @click.prevent="clearSelection">{{ $t('common.actions.clear') }}</button>
        </template>

        <template v-slot:activator="{ on }">
            <slot name="activator" :on="on"></slot>
        </template>
    </Modal>
</template>

<script>
import Modal from "@/components/common/Modal";
import CoreDatePicker from "@/components/common/datepicker/CoreDatePicker";
import Toggle from "@/components/common/Toggle"
export default {
    name: "ModalDatePicker",
    components: {
        Modal,
        CoreDatePicker,
        Toggle
    },
    props: {
        selectedDates: {
            type: Object,
            required: true,
            default: () => {}
        },
        bookings: {
            type: Array,
            required: false,
            default: () => [] // Use an empty array
        },
    },
    computed: {
        proxy: {
            get() {
                console.log("[DatePicker] - Getting value")
                return this.selectedDates;
            },
            set(val) {
                console.log("[DatePicker] - Setting new value")

                this.$emit("update:selectedDates", val);
            }
        },
        specialOffer: {
            get() {
                return this.$store.getters.getQuery.specialOffer
            },
            set(val) {
                // get the query
                let query = this.$store.getters.getQuery;
                // Get the copy
                let newQuery = this.getEditable(query);

                // set the val
                newQuery.specialOffer = val;

                // Set it as the new query
                this.$store.commit('setQuery', newQuery);
            }
        }
    },
    methods: {
        clearSelection: function() {
            // this.$set(this.selectedDate, 'start', undefined)
            // this.$set(this.selectedDate, 'end', undefined)

            this.proxy = {
                start: undefined,
                end: undefined
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    $border-radius: 5px;
    
    .btn {
        border-radius: $border-radius;
    }

    .btn-outline-primary {
        background-color: transparent !important;
        border-color: $primary-color !important;
        color: $primary-color !important;
        
    }
    .btn-outline-primary.active.show {
        background-color: $primary-color !important;
        color: white !important;
    }

    
</style>